<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="500px" transition="dialog-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="farmer_green" class="mb-4" large dark>Add a supplier</v-btn>
      </template>

      <v-form @submit.prevent="onAddSupplier" ref="form" v-model="valid">

        <v-card>
          <app-alert-error v-if="error" @dismissed="onDismiss" :text="error.message" class="mb-0"></app-alert-error>
          <!-- <v-card v-if="error" class="elevation-8"> -->
          <!-- </v-card> -->
          <v-card-title class="farmer_green white--text">
            <v-row class="mx-1">
              <h4>
                Create supplier
              </h4>
              <v-spacer></v-spacer>
              <v-icon class="font-weight-black white--text" @click="closeDialog">clear</v-icon>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>
          <v-card-text>

            <v-container>
              <v-layout row>
                <!-- Type -->
                <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                  <div class="mr-2">Type: </div>
                  <v-select v-model="type" :rules="validType" :items="supplierTypes" dense regular required></v-select>
                </v-flex>
                <template v-if="type === 'independent'">
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">First Name: </div>
                    <v-text-field name="firstName" id="firstName" type="text" :rules="fieldRules('First Name', 30)" v-model="indSupplier.firstName" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">Last Name: </div>
                    <v-text-field name="lastName" id="lastName" type="text" :rules="fieldRules('Last Name', 30)" v-model="indSupplier.lastName" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">Phone Number: </div>
                    <v-text-field name="phoneNumber" id="phoneNumber" type="tel" :rules="fieldRules('Phone Number', 20)" v-model="indSupplier.phoneNumber" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">E-mail: </div>
                    <v-text-field name="email" id="email" type="email" v-model="indSupplier.email" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap  align-center ">
                    <div class="mr-2">Password: </div>
                    <v-text-field name="password" id="password" type="text" :rules="fieldRules('Password', 20)" v-model="tempPass" dense regular required></v-text-field>
                    <v-icon class="mx-2" @click="copyPassword">content_copy</v-icon>
                    <v-btn color="farmer_green" @click="generatePassword" outlined depressed rounded dark small>Generate password</v-btn>
                  </v-flex>
                </template>
                <template v-if="type === 'business'">
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">First Name: </div>
                    <v-text-field name="firstName" id="firstName" type="text" :rules="fieldRules('First Name', 30)" v-model="BusSupplier.firstName" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">Last Name: </div>
                    <v-text-field name="lastName" id="lastName" type="text" :rules="fieldRules('Last Name', 30)" v-model="BusSupplier.lastName" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">Phone Number: </div>
                    <v-text-field name="phoneNumber" id="phoneNumber" type="tel" :rules="fieldRules('Phone Number', 20)" v-model="BusSupplier.phoneNumber" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">E-mail: </div>
                    <v-text-field name="email" id="email" type="email" :rules="fieldRules('E-mail', 50)" v-model="BusSupplier.email" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">Position
                      <ShowInfo infoText="The position in Company of the person who will be managing this account" />
                      :
                    </div>
                    <v-text-field name="position" id="position" type="text" :rules="fieldRules('Position', 50)" v-model="BusSupplier.position" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">Company Name: </div>
                    <v-text-field name="compnay-name" id="compnay-name" type="text" :rules="fieldRules('Company Name', 50)" v-model="BusSupplier.companyName" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                    <div class="mr-2">Company Website: </div>
                    <v-text-field name="website" id="website" type="url" v-model="BusSupplier.website" dense regular></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">

                    <div class="mr-2">Registration Number
                      <ShowInfo infoText="Company Registration Number" />
                      :
                    </div>
                    <v-text-field name="reg-nb" id="reg-nb" type="text" :rules="regNbRules" v-model="BusSupplier.companyRegNb" dense regular required></v-text-field>
                  </v-flex>
                  <v-flex xs10 offset-xs1 class="d-flex flex-wrap  align-center ">
                    <div class="mr-2">Password: </div>
                    <v-text-field name="password" id="password" type="text" :rules="fieldRules('Password', 20)" v-model="tempPass" dense regular required></v-text-field>
                    <v-icon class="mx-2" @click="copyPassword">content_copy</v-icon>
                    <v-btn color="farmer_green" @click="generatePassword" outlined depressed rounded dark small>Generate password</v-btn>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!isLoading" depressed class="farmer_green white--text" type="submit">
              Create supplier
            </v-btn>
            <v-btn v-else loading depressed type="submit" disabled>
              Create supplier
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
      <v-snackbar v-model="snackbar" color="farmer_green" :timeout="timeout" dense bottom right>
        {{ snackbarText }}
        <v-spacer></v-spacer>
        <v-icon color="white" @click="snackbar = false">close</v-icon>
      </v-snackbar>
    </v-dialog>
  </div>
</template>
<script>
import { store } from '@/store'

export default {
  name: 'AddSupplierDialog',
  components: { ShowInfo: () => import('@/components/shared/ShowInfo') },
  data() {
    return {
      dialog: false,
      valid: true,
      isLoading: false,
      type: '',
      supplierTypes: ['independent', 'business'],
      indSupplier: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '' // optional
      },
      BusSupplier: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        companyName: '',
        companyRegNb: '',
        website: '', // optional
        position: ''
      },
      tempPass: '',
      snackbar: false,
      timeout: 2000,
      snackbarText: ''
    }
  },
  computed: {
    error() {
      return this.$store.getters.error
    },
    fieldRules() {
      return (fieldName, maxChar) => [
        v => (!!v && !!v.trim()) || `${fieldName} is required`,
        v =>
          (v && v.length <= maxChar) ||
          `${fieldName} must be less than ${maxChar} characters`
      ]
    },
    regNbRules() {
      return [
        v => (!!v && !!v.trim()) || 'Registration Number is required',
        v => v.length <= 50 || 'Max 50 characters',
        v => v.match(/^[0-9]+$/) || 'Registration Number must contain only numbers'
      ]
    },
    validType() {
      return [
        v => !!v || 'Type is required',
        v =>
          v === 'independent' ||
          v === 'business' ||
          "Type can only take one of this valus 'independent', 'business'"
      ]
    },
    isPasswordGenerated() {
      return this.tempPass.length > 0
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.isLoading = false
      this.indSupplier = {}
      this.BusSupplier = {}
      this.$refs.form.reset()
    },
    onAddSupplier() {
      if (this.$refs.form.validate()) {
        this.isLoading = true

        if (this.type === 'independent') {
          const supplier = {
            ...this.indSupplier,
            tempPass: this.tempPass,
            type: this.type
          }
          this.$store
            .dispatch('createIndSupplier', supplier)
            .then(() => {
              this.closeDialog()
            })
            .catch(err => {
              this.isLoading = false
              store.commit('setError', err)
            })
        } else if (this.type === 'business') {
          const supplier = {
            ...this.BusSupplier,
            tempPass: this.tempPass,
            type: this.type
          }
          this.$store
            .dispatch('createBusSupplier', supplier)
            .then(() => {
              this.closeDialog()
            })
            .catch(err => {
              this.isLoading = false
              store.commit('setError', err)
            })
        }
      }
    },
    // Sequence generator function (commonly referred to as "range", e.g. Python, Matlab, Clojure, PHP etc)
    range(start, stop, step) {
      return Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
      )
    },
    generatePassword() {
      this.tempPass = ''
      const numbers = this.range(49, 57, 1)
      const upperCaseBeforeO = this.range(65, 78, 1)
      const upperCaseAfterO = this.range(80, 90, 1)
      // const lowerCase = this.range(97, 122, 1)
      const nbCharacters = 8
      const charCodes = [...numbers, ...upperCaseBeforeO, ...upperCaseAfterO]

      for (let j = 0; j < nbCharacters; j++) {
        const characterCode =
          charCodes[Math.floor(Math.random() * charCodes.length)]
        this.tempPass += String.fromCharCode(characterCode)
      }
    },
    copyPassword() {
      const copyText = document.getElementById('password')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.snackbarText = 'Copied the text: ' + copyText.value
      this.snackbar = true
    }
  }
}
</script>
